import { Injectable } from '@angular/core';
import { Accrual, PointsSummary, Tranche } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class PointsSummaryHelper {
  constructor() {}

  public tranchesIn12Months(pointsSummary: PointsSummary): Tranche[] {
    const nextYearDate = new Date().setFullYear(new Date().getFullYear() + 1);
    return pointsSummary.tranches.filter(
      (tranche) => tranche.expiryDate <= new Date(nextYearDate),
    );
  }

  public expiringPointsIn12Months(pointsSummary: PointsSummary): number {
    return this.tranchesIn12Months(pointsSummary).reduce(
      (sum, tranche) => sum + tranche.balance,
      0,
    );
  }

  public expiringPointsAtDate(
    pointsSummary: PointsSummary,
    date: Date,
  ): number {
    const filtered = pointsSummary?.tranches.find(
      (tranche) => tranche.expiryDate.toDateString() === date.toDateString(),
    );
    return filtered?.balance || 0;
  }

  public getTotalAccrualPoints(pointsSummary: PointsSummary): number {
    return pointsSummary.accruals.reduce(
      (sum, accrual) => sum + accrual.amount,
      0,
    );
  }

  public getFirstAccrualDate(pointsSummary: PointsSummary): Date | null {
    if (
      !Array.isArray(pointsSummary.accruals) ||
      pointsSummary.accruals.length === 0
    ) {
      return null;
    }
    const pointsSummaryClone = Array.from(pointsSummary.accruals);
    pointsSummaryClone.sort((firstAccrual: Accrual, secondAccrual: Accrual) => {
      return (
        +new Date(firstAccrual.transactionDate) -
        +new Date(secondAccrual.transactionDate)
      );
    });
    return pointsSummaryClone[0].transactionDate;
  }
}
